module.exports = __webpack_public_path__ + "static/media/KNC-logo.5f543a25.png";